<template>
    <pendo-multiselect-filter
        ref="menu"
        :options="options"
        :loading="loading"
        :menu-width="250"
        :show-search="true"
        :show-action="true"
        :value="value"
        label-key="name"
        value-key="id"
        :entity-name="$t('multiselectLabelsFilter.labels')"
        :all-label="$t('multiselectLabelsFilter.allLabels')"
        @input="setValue"
        @edit="onEdit"
        @delete="onDelete"
        @open="loadOptions"
        @leave-lower-bound="onLeaveLowerBound">
        <template #footer="{ handleKeydown }">
            <pendo-button
                ref="createLabelButton"
                theme="app"
                type="subtle"
                data-cy="create-label"
                prefix-icon="plus"
                :label="createLabelButtonText"
                @click="createLabel"
                @keydown="handleKeydown($event, footerKeydownOverrides(createLabel))" />
        </template>
    </pendo-multiselect-filter>
</template>

<script>
import { PendoButton, PendoMultiselectFilter, PendoMultiselectHelpers } from '@pendo/components';
import LabelActions from '@/common/labels/mixins/label-actions.mixin.js';
import { onLeaveLowerBound } from '@/utils/multiselect-keyboard';
import { mapActions } from 'vuex';
const { actionButtonKeyOverride, verticalNavigationKeyOverride } = PendoMultiselectHelpers;

export default {
    name: 'MultiselectLabelsFilter',
    components: {
        PendoMultiselectFilter,
        PendoButton,
    },
    mixins: [LabelActions],
    props: {
        availableLabels: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['create-label', 'input'],
    data () {
        return {
            options: [],
        };
    },
    methods: {
        ...mapActions('labels', ['loadAll']),
        async loadOptions () {
            await this.loadAll();
            this.setOptions();
        },
        setOptions () {
            this.options = this.availableLabels.map((label) => {
                return {
                    ...label,
                    actions: this.renderActions(label),
                };
            });
        },
        createLabel () {
            this.close();
            this.$emit('create-label');
        },
        close () {
            this.$refs.menu.close();
        },
        onLeaveLowerBound () {
            onLeaveLowerBound(this.$refs.menu, null, this.$refs.createLabelButton);
        },
        setValue (value) {
            this.$emit('input', value);
        },
        footerKeydownOverrides (actionFn) {
            return {
                ...actionButtonKeyOverride(actionFn),
                ...verticalNavigationKeyOverride(this.$refs.menu.focusInput),
            };
        },
    },
};
</script>
